module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/link_big-5492b2e503c646164ce52caf228b4f9b.svg";